import React, { useEffect } from "react";
import "./security.css";
import roles_profile_team1 from "assets/security/roles_profile_team1.png";
import roles_profile_team2 from "assets/security/roles_profile_team2.png";
import roles_profile_team3 from "assets/security/roles_profile_team3.png";
import roles_profile_team4 from "assets/security/roles_profile_team4.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const RolesProfilesTeamsSecurity = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Roles Profiles Teams Security | The Realtor Desk" description="" />
      <div className="sub-page--outer">
        <SubPageHeader
            title="Control Access with Role-Based Security"
            subTitle="Safeguard your data by implementing role-based security access, ensuring that only authorized individuals can view specific information."
        />
        <div className="container">
          <TextBlock
              shortTitle=""
              title="Controlled Real Estate Data Access in Realtor CRM"
              description="Your data is one of your most valuable assets. That's why Realtor's role-based access control features allow you to manage data accessibility based on teams, profiles, and designations. This added layer of security ensures that your data remains protected and is only accessible to the right individuals."
              textSize="large"
          />
          <ImageWithTextBlock
              shortTitle="Customize Data Access for Enhanced Security"
              title="Custom Roles and Profiles with Restricted Access"
              description="We understand the importance of controlling access to sensitive data. Realtor Desk allows you to create custom roles and profiles, enabling you to restrict access to specific information. This ensures that only authorized users can view certain data, adding an extra layer of security to your operations."
              image={roles_profile_team1}
              imagePosition="right"
          />
          <ImageWithTextBlock
              shortTitle="Protect Sensitive Lead Information"
              title="Restricted Access to Real Estate Leads in CRM"
              description="Realtor Desk enables you to restrict access to lead information based on roles, profiles, teams, or hierarchy. This ensures that only authorized individuals can access sensitive lead data, enhancing security and safeguarding your most valuable asset."
              image={roles_profile_team2}
              imagePosition="left"
          />
          <ImageWithTextBlock
              shortTitle="Camouflaged Lead Communication"
              title="Protect Lead Data with Secure Communication"
              description="The Realtor Desk camouflages the contact details of leads to prevent unauthorized access. Communication, including calls, emails, and SMS messages, takes place directly through the platform. The cloud telephony system seamlessly connects calls between the lead and your phone, while emails and SMS can be sent with a single click. This approach safeguards your lead data and prevents sales representatives from taking their lead lists with them when they leave."
              image={roles_profile_team3}
              imagePosition="right"
          />
          <ImageWithTextBlock
              shortTitle="Complete Control on Data Exports"
              title="Manage Team Permissions for Data Exports"
              description="Your data is one of your most valuable assets, and Realtor Desk gives you full control over its export permissions. You can determine who is authorized to generate exports and whether they can access sensitive contact detail fields. This customizable control ensures that your data remains secure and only accessible to the right people."
              image={roles_profile_team4}
              imagePosition="left"
          />
        </div>
      </div>
    </>
  );
};

export default RolesProfilesTeamsSecurity;
